<template>
  <div v-if="id" class="progress__model">
    <div class="progress__title">Training Now</div>
    <div class="progress__label">
      <span>{{ name }}</span>
      <span>{{ progress }}%</span>
    </div>
    <span>Score: {{ map }}%</span>
    <div class="progress__line">
      <div class="progress__value" :style="{ 'width': `${progress}%` }" />
    </div>
    <el-tooltip class="close-tooltip" content="Stop Training">
      <el-popover
        v-model="visible"
        placement="bottom"
        trigger="click"
        width="250">
        <div class="acr-bold-18">Stop "{{ name }}"</div>
        <div class="stop-status">
          <el-radio v-model="stopStatus" label="done">Model is good enough</el-radio>
          <el-radio v-model="stopStatus" label="error">Just cancel training</el-radio>
        </div>
        <div class="popover-buttons">
          <el-button @click="visible = false">Cancel</el-button>
          <el-button @click="stopTraining" type="danger">Stop</el-button>
        </div>
        <el-button v-if="progress < 100" type="text" class="close-btn" slot="reference">
          <svgicon name="Close"></svgicon>
        </el-button>
      </el-popover>
    </el-tooltip>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { getModelInProgress, stopTrainingModel } from '@/api/models';

export default {
  name: "ProgressModel",
  data() {
    return {
      id: null,
      map: 0,
      name: '',
      progress: 0,
      stopStatus: 'done',
      visible: false,
    }
  },
  methods: {
    ...mapActions({
      error: 'error',
      success: 'success',
    }),
    async stopTraining() {
      const { data = {} } = await stopTrainingModel(this.id, { status: this.stopStatus });
      if (data.error) {
        this.error(data.msg);
      } else {
        this.success(data.msg);
      }

      await this.getProgressModel();
      this.visible = false;
    },
    async getProgressModel() {
      const { data = {} } = await getModelInProgress();
      this.id = data.model_id;
      this.map = data.model_map;
      this.name = data.model_name;
      this.progress = data.model_progress;
    },
  },
  created() {
    this.getProgressModel();
  },
}
</script>

<style scoped lang="scss">
.progress__model {
  display: grid;
  grid-template-columns: 90px 1fr 20px;
  align-items: center;
  justify-items: flex-end;
  column-gap: 16px;
  width: 100%;
  height: 100%;
  padding: 8px 18px 8px 0;
  border-right: 1px solid var(--border-color);
  font-size: 12px;
}

.progress__title {
  font-size: 14px;
  font-weight: 700;
}

.progress__label {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.progress__line {
  width: 100%;
  height: 9px;
  background: rgba(var(--green-rgb), 0.2);
  border: 1px solid rgba(var(--green-rgb), 0.2);
  border-radius: 6px;
  overflow: hidden;
}

.progress__value {
  height: 100%;
  background: var(--green);
}

.close-tooltip {
  grid-column: 3;
  grid-row: 1 / 3;
}

.close-btn {
  svg {
    width: 14px;
    height: 14px;
    color: var(--primary);
  }
}

.stop-status {
  margin-top: 15px;

  /deep/ {
    .el-radio {
      &:first-child {
        margin-bottom: 4px;
      }

      .el-radio__label {
        color: var(--primary);
      }
    }
  }
}

.popover-buttons {
  display: flex;
  justify-content: flex-end;
  margin-top: 15px;

  button {
    padding: 9px 20px;
    font-weight: 700;
  }
}
</style>
